import { ChatSidebarProvider } from "@/contexts/ChatSidebarContext";
import { MobileSidebarProvider } from "@/contexts/MobileSidebarContext";
import { ChatSidebar } from "../components/ChatSidebar";
import { Sidebar } from "../components/Sidebar";
import { TopBar } from "../components/TopBar";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <MobileSidebarProvider>
      <ChatSidebarProvider>
        {/* h-dvh + overflow-hidden pins TopBar (and its menu button) while <main>
            scrolls internally — with min-h-screen the whole document scrolled on
            mobile, pushing the nav off-screen and under the iOS status bar */}
        <div className="flex h-dvh overflow-hidden bg-primary">
          <Sidebar />
          <div className="flex-1 flex flex-col min-w-0 bg-background">
            <TopBar />
            <main className="flex-1 overflow-auto p-4 sm:p-6 md:p-8 bg-background text-content-foreground">
              {children}
            </main>
          </div>
          <ChatSidebar />
        </div>
      </ChatSidebarProvider>
    </MobileSidebarProvider>
  );
}
